// Navigation helper for React Router v6
// Use the useNavigate hook directly in components instead
// This file is kept for backward compatibility with minimal changes

let navigate = null;
let listeners = [];

export const setNavigate = (nav) => {
  navigate = nav;
};

export const notifyListeners = (location, action) => {
  listeners.forEach(listener => listener(location, action));
};

const history = {
  push: (path) => {
    if (navigate) {
      navigate(path);
    } else {
      console.warn('Navigate function not initialized. Use useNavigate hook directly.');
    }
  },
  replace: (path) => {
    if (navigate) {
      navigate(path, { replace: true });
    }
  },
  goBack: () => {
    if (navigate) {
      navigate(-1);
    }
  },
  listen: (listener) => {
    listeners.push(listener);
    // Return unlisten function
    return () => {
      listeners = listeners.filter(l => l !== listener);
    };
  }
};

export default history;